module.exports = __webpack_public_path__ + "img/hr-radar-integration.9e5afbf9.png";